import React, { useState } from 'react';
import {
    Box,
    Button,
    TextField,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    InputLabel,
    FormControl,
    Select,
    MenuItem,
    OutlinedInput,
    Checkbox
} from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import ApiHelper from 'utils/apiHelper';
import { validateEmail } from 'utils/commonHelpers';

const AddUserDialog = ({ onClose, userGroupsData }) => {
    const [username, setUsername] = useState('');
    const [email, setEmail] = useState('');
    const [confirmEmail, setConfirmEmail] = useState('');
    const [userGroupId, setUserGroupId] = useState([]);
    const [loading, setLoading] = useState(false);

    const handleChangeUserGroupId = (event) => {
        const {
            target: { value }
        } = event;
        setUserGroupId(typeof value === 'string' ? value.split(',') : value);
    };

    const handleSubmit = () => {
        if (username === '') {
            toast.error('Username is required.');
            return true;
        } else {
            if (email === '') {
                toast.error('Email is required.');
                return true;
            }
            if (!validateEmail(email)) {
                toast.error('Invalid email format.');
                return true;
            }
            if (email !== confirmEmail) {
                toast.error(`Confirm email is incorrect`);
                return true;
            }
        }
        if (userGroupId.length === 0) {
            toast.error('Please select the user group');
            return true;
        }
        setLoading(true);

        ApiHelper.post('/api/management/users/', {
            username: username,
            email: email,
            user_group_names: userGroupId
        })
            .then(() => {
                toast.success('Successfully added.');
                onClose();
                setLoading(false);
            })
            .catch((err) => {
                if (err.response.data.message !== '') {
                    toast.error(`Failed! ${err.response.data.message}`);
                } else {
                    toast.error('Failed to add a new user');
                }
                setLoading(false);
            });
    };

    return (
        <Dialog open={true} onClose={onClose}>
            <DialogTitle sx={{ fontSize: '16px' }}>Add New User</DialogTitle>
            <DialogContent sx={{ minWidth: '500px' }}>
                <Box sx={{ mb: 3, mt: 3 }}>
                    <TextField
                        sx={{
                            width: '100%'
                        }}
                        label="Username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                    />
                </Box>
                <Box sx={{ mb: 3, mt: 3 }}>
                    <TextField
                        sx={{
                            width: '100%'
                        }}
                        label="Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                </Box>
                <Box sx={{ mb: 3, mt: 3 }}>
                    <TextField
                        sx={{
                            width: '100%'
                        }}
                        label="Confirm Email"
                        value={confirmEmail}
                        onChange={(e) => setConfirmEmail(e.target.value)}
                    />
                </Box>
                <Box sx={{ mb: 3, mt: 3 }}>
                    <FormControl sx={{ width: '100%' }}>
                        <InputLabel>Select the user group</InputLabel>
                        <Select
                            displayEmpty
                            value={userGroupId}
                            name="userGroupId"
                            multiple
                            input={<OutlinedInput label="Select the user group" />}
                            onChange={handleChangeUserGroupId}
                            renderValue={(selected) => selected.join(', ')}
                        >
                            {userGroupsData.map((data, key) => (
                                <MenuItem value={data.name} key={key}>
                                    <Checkbox checked={userGroupId.indexOf(data.name) > -1} />
                                    {data.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <LoadingButton onClick={handleSubmit} loading={loading} color="primary" variant="contained">
                    <span>Submit</span>
                </LoadingButton>
            </DialogActions>
        </Dialog>
    );
};

AddUserDialog.propTypes = {
    onClose: PropTypes.func,
    userGroupsData: PropTypes.array
};

export default AddUserDialog;
